// export const BaseURL = 'http://localhost:4001/api/v1'

// export const LoginURL = "/login"

// export const FeedsURL = "/home/feeds"

// export const CommentURL = '/home/comments/'

// export const ReactionURL = "/home/reaction"

// export const UploadURL = "/home/upload"

export const URL = {
    base: 'https://idea.protivitiglobal.me/api/v1',
    // base: 'http://localhost:4001/api/v1',
    login: '/login',
    logout: '/login/logout',
    profile: "/home/profile",
    refresh: '/login/refresh',
    changeRole:'/login/changeRole',
    feeds: '/home/feeds',
    myIdeas: "/home/myIdeas",
    latestIdeas: "/home/latestIdeas",
    topIdeas: "/home/topIdeas",
    trendIdeas: "/home/trendIdeas",
    comment: '/home/comments/',
    reaction: '/home/reaction',
    upload: '/home/upload',
    ideasReview: '/admin/ideas',
    implementAreas: '/home/implementAreas',
    expectedOutcomes: '/home/expectedOutcomes',
    categoryList: '/home/ideasCategory',
    departmentList: '/home/departmentList',
    postIdea: "/home/postIdea",
    postPhuketIdea: "/home/postPhuketIdea",
    updateIdeaStatus: "/home/updateIdeaStatus",
    topEmp: "/home/topEmployees",
    juryDetails:"/home/getJuryDetails",
    juryDetailsAdmin:"/admin/getJuryDetails",
    updateJuryDetailsAdmin:"/admin/editJuryDetails",
    createJuryProfile:"/admin/createJuryProfile",
    adminUsers: "/admin/getAdminUsers",
    createAdminUser: "/admin/createAdminUsers",
    editAdminUser: "/admin/editAdminUsers",
    dashboard: "/admin/dashboard",
    ideaDetail:'/home/ideaDetail',
    postFeedback: "/home/postfeedback"

}